import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDownloadInfographic } from "../../hooks/useInfographic";

const InforgraphicForm = ({ showModal, data:infoData }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    city: "",
  });
  const [loading, setLoading] = useState(false);

  const { mutate } = useDownloadInfographic({
    onSuccessCallback: async (data) => {
      try {
        const res = await fetch(infoData.downloadUrl);
        if (!res.ok) throw new Error("Failed to download file");

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = infoData.fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
        toast.error("Unable to download file. Please try again.");
      }

      setFormData({
        name: "",
        email: "",
        city: "",
      });

      setLoading(false);
      showModal();
    },

    onErrorCallback: (errorMsg) => {
      setLoading(false);
      toast.error(errorMsg);
      showModal();
    },
  });



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    mutate({
      data: formData,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="mt-5 flex flex-col gap-4 w-full">
      {/* Name */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">Name*</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full"
          required
        />
      </div>
      {/* Email Address */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">Email*</label>
        <input
          type="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3 focus:outline-none focus:border-gray-500 w-full"
        />
      </div>
      {/* city */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">City*</label>
        <input
          type="text"
          name="city"
          value={formData.city}
          onChange={handleChange}
          placeholder="Enter your city"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full"
          required
        />
      </div>

      {/* Submit Button */}
      <div className=" flex flex-col gap-8 justify-between">
        <button
          disabled={loading}
          type="submit"
          className="bg-[#002DA3] text-white font-bold px-6 py-3 rounded-[32px] hover:bg-blue-700 transition duration-300"
        >
          {" "}
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default InforgraphicForm;
